import * as common from "./common";
import levels from "./levels";
import cps from "./cps";
import me from "./me";
import pins from "./pins";
import setting from "./setting";
import terms from "./terms";
import users from "./users";
import * as ip from "./ip"
export default {
    ...common,
    levels,
    cps,
    me,
    pins,
    setting,
    terms,
    users,
    ...ip,
};